export default "__VITE_ASSET__USU9O_87__"